<template lang="pug">
  #navbar
    b-navbar(toggleable='md', type='dark')
      b-navbar-toggle(target='nav_collapse')
      b-navbar-brand(href='#', style="height:50px")
        h3(v-if="usuario && usuario.NomeEmp") Pedido Web - {{ usuario.NomeEmp }}
        h3(v-else) Pedido Web
        //- b-img(:src="logo", width="150px")
      b-collapse#nav_collapse(v-if="!$route.meta.public && usuario", is-nav)
        b-navbar-nav.ml-auto
          b-nav-item(to="/clientes") Clientes
          b-nav-item(to="/pedidos") Pedidos
          b-nav-item(to="/relatorios", v-show="usuario.CodRep") Relatórios
          b-nav-item-dropdown.link-dropdown(:text=`'Olá ' + usuario.NomRep` , right)
            b-dropdown-item(@click="logOut") Logout

</template>

<script>
import logo from '@/assets/images/logo2.png';

export default {
  data () {
    return {
      logo: logo
    };
  },
  computed: {
    usuario () {
      // console.log('USUARIO: ', this.$store.getters.user);
      return this.$store.getters.user;
    }
  },
  methods: {
    logOut () {
      const vm = this;
      window.getApp.$emit('APP_LOGOUT');
    }
  }
};
</script>
<style lang="scss">
  #navbar{
    box-shadow: 2px 2px 8px rgba(58, 45, 127, 0.53);
    background-color: #f6f3ea;
    a{
      font-size: 18px;
      color: #3A2D7F !important;
      font-weight: 600 !important;
    }
    .nav-item:hover{
      background-color: rgba(0, 88, 177, 0.082);
      border-radius: 17px;
    }
    .nav-link.active{
      background-color: rgba(0, 88, 177, 0.082);
      border-radius: 17px;
    }
    .link-dropdown:focus {
      a{
        color: #3A2D7F!important;
      }
    }
    .link-dropdown {
      color: #3A2D7F!important;
      font-weight: 600!important;
      a{
        color: #3A2D7F !important;
        font-weight: 600 !important;
      }
      span{
        color: #3A2D7F !important;
        font-weight: 600 !important;
      }
    }
    .link-dropdown.active{
      color: #3A2D7F!important;
      font-weight: 600!important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Navbar.vue